export const isWebview = (userAgent?: string) => {
  if (userAgent) {
    return /webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i.test(userAgent);
  }
  return false;
};
